import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  inspectionDetaildata: [],
  itemsPerPage: 10,
  currentPage: 1,
  totalCount: 0,
  previewUrl: null,
  pdfUrl: null,
  downloadCsv : null || [],
};

const fetchStart = (state) => {
  state.isLoading = true;
  state.error = null;
};

const fetchSuccess = (state, action) => {
  state.isLoading = false;
  state.error = null;
  state.inspectionDetaildata = action.payload;
  state.totalCount = action.payload.totalCount;
};

const fetchCsvSuccess = (state, action) => {
  state.isLoading = false;
  state.error = null;
  state.downloadCsv = action.payload;
};

const fetchDownloadCsvSuccess = fetchCsvSuccess;

const fetchFailure = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const fetchDetailsStart = fetchStart;

const fetchDetailsSuccess = (state, action) => {
  state.isLoading = false;
  state.inspectionDetaildata = action.payload;
  state.totalCount = action.payload.totalCount;
  state.error = null;
};

const fetchDetailsFailure = fetchFailure;

const deleteStart = fetchStart;

const deleteSuccess = (state, action) => {
  state.isLoading = false;
  state.inspectionDetaildata = action.payload;
  state.error = null;
};

const deleteFailure = fetchFailure;

const inspectionDetailSlice = createSlice({
  name: "inspectionDetails",
  initialState,
  reducers: {
    // Main inspection fetch actions
    fetchInspectionStart: fetchStart,
    fetchInspectionSuccess: fetchSuccess,
    fetchInspectionFailure: fetchFailure,

    // Welding Gas actions
    fetchWeldingGasStart: fetchStart,
    fetchWeldingGasSuccess: fetchSuccess,
    fetchWeldingGasFailure: fetchFailure,

    // Welding Machine Calibration actions
    fetchWeldingMachineCallibrationStart: fetchStart,
    fetchWeldingMachineCallibrationSuccess: fetchSuccess,
    fetchWeldingMachineCallibrationFailure: fetchFailure,

    // Welding WPQ actions
    fetchWeldingWPQStart: fetchStart,
    fetchWeldingWPQSuccess: fetchSuccess,
    fetchWeldingWPQFailure: fetchFailure,

    // Weld Log actions
    fetchWeldLogStart: fetchStart,
    fetchWeldLogSuccess: fetchSuccess,
    fetchWeldLogFailure: fetchFailure,

    // Ncr Report actions
    fetchNcrReportStart: fetchStart,
    fetchNcrReportSuccess: fetchSuccess,
    fetchNcrReportFailure: fetchFailure,

    // Project Report actions
    fetchProjectReportStart: fetchStart,
    fetchProjectReportSuccess: fetchSuccess,
    fetchProjectReportFailure: fetchFailure,

    // ISO Material Details actions
    fetchIsoMaterialDetailsStart: fetchDetailsStart,
    fetchIsoMaterialDetailsSuccess: fetchDetailsSuccess,
    fetchIsoMaterialDetailsFailure: fetchDetailsFailure,

    fetchIsoMaterialFilterStart: fetchDetailsStart,
    fetchIsoMaterialFilterSuccess: fetchDetailsSuccess,
    fetchIsoMaterialFilterFailure: fetchDetailsFailure,

    fetchWeldingGasFilterStart: fetchDetailsStart,
    fetchWeldingGasFilterSuccess: fetchDetailsSuccess,
    fetchWeldingGasFilterFailure: fetchDetailsFailure,

    // Welding Gas Details actions
    fetchWeldingGasDetailsStart: fetchDetailsStart,
    fetchWeldingGasDetailsSuccess: fetchDetailsSuccess,
    fetchWeldingGasDetailsFailure: fetchDetailsFailure,

    fetchWeldingMachineFilterStart: fetchDetailsStart,
    fetchWeldingMachineFilterSuccess: fetchDetailsSuccess,
    fetchWeldingMachineFilterFailure: fetchDetailsFailure,
    // Weld Machine Calibration Details actions
    fetchWeldMachineCalibDetailsStart: fetchDetailsStart,
    fetchWeldMachineCalibDetailsSuccess: fetchDetailsSuccess,
    fetchWeldMachineCalibDetailsFailure: fetchDetailsFailure,

    fetchWeldingWPQFilterStart: fetchDetailsStart,
    fetchWeldingWPQFilterSuccess: fetchDetailsSuccess,
    fetchWeldingWPQFilterFailure: fetchDetailsFailure,

    fetchWeldingLogFilterStart: fetchDetailsStart,
    fetchWeldingLogFilterSuccess: fetchDetailsSuccess,
    fetchWeldingLogFilterFailure: fetchDetailsFailure,

    // Welding WPQ Details actions
    fetchWeldingWPQDetailsStart: fetchDetailsStart,
    fetchWeldingWPQDetailsSuccess: fetchDetailsSuccess,
    fetchWeldingWPQDetailsFailure: fetchDetailsFailure,

    fetchNcrReportFilterStart: fetchDetailsStart,
    fetchNcrReportFilterSuccess: fetchDetailsSuccess,
    fetchNcrReportFilterFailure: fetchDetailsFailure,

    fetchProjectReportFilterStart: fetchDetailsStart,
    fetchProjectReportFilterSuccess: fetchDetailsSuccess,
    fetchProjectReportFilterFailure: fetchDetailsFailure,

    // Ncr Report Details actions
    fetchNcrDetailsStart: fetchDetailsStart,
    fetchNcrDetailsSuccess: fetchDetailsSuccess,
    fetchNcrDetailsFailure: fetchDetailsFailure,

    // Weld Log Details actions
    fetchWeldLogDetailsStart: fetchDetailsStart,
    fetchWeldLogDetailsSuccess: fetchDetailsSuccess,
    fetchWeldLogDetailsFailure: fetchDetailsFailure,

    // Project Report Details actions
    fetchProjectDetailsStart: fetchDetailsStart,
    fetchProjectDetailsSuccess: fetchDetailsSuccess,
    fetchProjectDetailsFailure: fetchDetailsFailure,

    // Delete Ncr Report actions
    deleteNcrReportStart: deleteStart,
    deleteNcrReportSuccess: deleteSuccess,
    deleteNcrReportFailure: deleteFailure,

    // Delete Project Report actions
    deleteProjectReportStart: deleteStart,
    deleteProjectReportSuccess: deleteSuccess,
    deleteProjectReportFailure: deleteFailure,

    // Delete Weld Log actions
    deleteWeldLogStart: deleteStart,
    deleteWeldLogSuccess: deleteSuccess,
    deleteWeldLogFailure: deleteFailure,

    // Delete Welding WPQ actions
    deleteWeldingWPQStart: deleteStart,
    deleteWeldingWPQSuccess: deleteSuccess,
    deleteWeldingWPQFailure: deleteFailure,

    // Delete Weld Machine Calibration actions
    deleteWeldMachineCaliStart: deleteStart,
    deleteWeldMachineCaliSuccess: deleteSuccess,
    deleteWeldMachineCaliFailure: deleteFailure,

    // Delete Welding Gas actions
    deleteWeldingGasStart: deleteStart,
    deleteWeldingGasSuccess: deleteSuccess,
    deleteWeldingGasFailure: deleteFailure,

    // Delete ISO Material actions
    deleteIsoMaterialStart: deleteStart,
    deleteIsoMaterialSuccess: deleteSuccess,
    deleteIsoMaterialFailure: deleteFailure,

    // // Preview Ncr Report Pdf
    previewNcrPdfStart: (state) => {
      state.previewLoading = true;
      state.error = null;
      state.previewUrl = null;
    },
    previewNcrPdfSuccess: (state, action) => {
      state.previewLoading = false;
      state.previewUrl = action.payload;
      state.error = null;
    },
    previewNcrPdfFailure: (state, action) => {
      state.previewLoading = false;
      state.error = action.payload;
      state.previewUrl = null;
    },

    // Download Ncr Report Pdf
    downloadNcrPdfStart: (state) => {
      state.downloadLoading = true;
      state.error = null;
      state.pdfUrl = null;
    },
    downloadNcrPdfSuccess: (state, action) => {
      state.downloadLoading = false;
      state.pdfUrl = action.payload;
      state.error = null;
    },
    downloadNcrPdfFailure: (state, action) => {
      state.downloadLoading = false;
      state.error = action.payload;
      state.pdfUrl = null;
    },

    // // Preview Project Report Pdf
    previewPdfStart: (state) => {
      state.previewLoading = true;
      state.error = null;
      state.previewUrl = null;
    },
    previewPdfSuccess: (state, action) => {
      state.previewLoading = false;
      state.previewUrl = action.payload;
      state.error = null;
    },
    previewPdfFailure: (state, action) => {
      state.previewLoading = false;
      state.error = action.payload;
      state.previewUrl = null;
    },

    // // Doownload Project Report Pdf
    downloadPdfStart: (state) => {
      state.downloadLoading = true;
      state.error = null;
      state.pdfUrl = null;
    },
    downloadPdfSuccess: (state, action) => {
      state.downloadLoading = false;
      state.pdfUrl = action.payload;
      state.error = null;
    },
    downloadPdfFailure: (state, action) => {
      state.downloadLoading = false;
      state.error = action.payload;
      state.pdfUrl = null;
    },

    // // Download Iso-material form Pdf
    downloadIsomaterialPdfStart: (state) => {
      state.downloadLoading = true;
      state.error = null;
      state.pdfUrl = null;
    },
    downloadIsomaterialPdfSuccess: (state, action) => {
      state.downloadLoading = false;
      state.pdfUrl = action.payload;
      state.error = null;
    },
    downloadIsomaterialPdfFailure: (state, action) => {
      state.downloadLoading = false;
      state.error = action.payload;
      state.pdfUrl = null;
    },

    // // Download Iso-material form Pdf
    downloadIsoWeldLogPdfStart: (state) => {
      state.downloadLoading = true;
      state.error = null;
      state.pdfUrl = null;
    },
    downloadIsoWeldLogPdfSuccess: (state, action) => {
      state.downloadLoading = false;
      state.pdfUrl = action.payload;
      state.error = null;
    },
    downloadIsoWeldLogPdfFailure: (state, action) => {
      state.downloadLoading = false;
      state.error = action.payload;
      state.pdfUrl = null;
    },
    
    // ISO Maaterial Download CSV actions
    fetchIsoMaterialDownloadCSVStart: fetchStart,
    fetchIsoMaterialDownloadCSVSuccess: fetchDownloadCsvSuccess,
    fetchIsoMaterialDownloadCSVFailure: fetchFailure,

    // Welding Machine Download CSV actions
    fetchWeldingMachineDownloadCSVStart: fetchStart,
    fetchWeldingMachineDownloadCSVSuccess: fetchDownloadCsvSuccess,
    fetchWeldingMachineDownloadCSVFailure: fetchFailure,

    // Welding WPQ  Download CSV actions
    fetchWeldingWPQDownloadCSVStart: fetchStart,
    fetchWeldingWPQDownloadCSVSuccess: fetchDownloadCsvSuccess,
    fetchWeldingWPQDownloadCSVFailure: fetchFailure,

    // Weld Log Download CSV actions
    fetchWeldLogDownloadCSVStart: fetchStart,
    fetchWeldLogDownloadCSVSuccess: fetchDownloadCsvSuccess,
    fetchWeldLogDownloadCSVFailure: fetchFailure,

    // Welding gas Download CSV actions
    fetchWeldingGasDownloadCSVStart: fetchStart,
    fetchWeldingGasDownloadCSVSuccess: fetchDownloadCsvSuccess,
    fetchWeldingGasDownloadCSVFailure: fetchFailure,

    // Pagination actions
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setItemsPerPage(state, action) {
      state.itemsPerPage = action.payload;
    },
  },
});

export const {
  fetchInspectionStart,
  fetchInspectionSuccess,
  fetchInspectionFailure,
  fetchWeldingGasStart,
  fetchWeldingGasSuccess,
  fetchWeldingGasFailure,
  setCurrentPage,
  setItemsPerPage,
  fetchWeldingMachineCallibrationStart,
  fetchWeldingMachineCallibrationSuccess,
  fetchWeldingMachineCallibrationFailure,
  fetchWeldingWPQStart,
  fetchWeldingWPQSuccess,
  fetchWeldingWPQFailure,
  fetchWeldLogStart,
  fetchWeldLogSuccess,
  fetchWeldLogFailure,
  fetchNcrReportStart,
  fetchNcrReportSuccess,
  fetchNcrReportFailure,
  fetchProjectReportStart,
  fetchProjectReportSuccess,
  fetchProjectReportFailure,

  fetchIsoMaterialDetailsStart,
  fetchIsoMaterialDetailsSuccess,
  fetchIsoMaterialDetailsFailure,
  fetchWeldingGasDetailsStart,
  fetchWeldingGasDetailsSuccess,
  fetchWeldingGasDetailsFailure,
  fetchWeldMachineCalibDetailsStart,
  fetchWeldMachineCalibDetailsSuccess,
  fetchWeldMachineCalibDetailsFailure,
  fetchWeldingWPQDetailsStart,
  fetchWeldingWPQDetailsSuccess,
  fetchWeldingWPQDetailsFailure,
  fetchWeldLogDetailsStart,
  fetchWeldLogDetailsSuccess,
  fetchWeldLogDetailsFailure,
  fetchProjectDetailsStart,
  fetchProjectDetailsSuccess,
  fetchProjectDetailsFailure,
  fetchNcrDetailsStart,
  fetchNcrDetailsSuccess,
  fetchNcrDetailsFailure,

  deleteNcrReportStart,
  deleteNcrReportSuccess,
  deleteNcrReportFailure,
  deleteProjectReportStart,
  deleteProjectReportSuccess,
  deleteProjectReportFailure,
  deleteWeldLogStart,
  deleteWeldLogSuccess,
  deleteWeldLogFailure,
  deleteWeldingWPQFailure,
  deleteWeldingWPQStart,
  deleteWeldingWPQSuccess,
  deleteWeldMachineCaliFailure,
  deleteWeldMachineCaliStart,
  deleteWeldMachineCaliSuccess,
  deleteWeldingGasStart,
  deleteWeldingGasFailure,
  deleteWeldingGasSuccess,
  deleteIsoMaterialFailure,
  deleteIsoMaterialStart,
  deleteIsoMaterialSuccess,

  previewPdfStart,
  previewPdfSuccess,
  previewPdfFailure,
  downloadPdfStart,
  downloadPdfSuccess,
  downloadPdfFailure,
  downloadIsomaterialPdfStart,
  downloadIsomaterialPdfSuccess,
  downloadIsomaterialPdfFailure,
  previewNcrPdfStart,
  previewNcrPdfSuccess,
  previewNcrPdfFailure,
  downloadNcrPdfStart,
  downloadNcrPdfSuccess,
  downloadNcrPdfFailure,
  downloadIsoWeldLogPdfStart,
  downloadIsoWeldLogPdfSuccess,
  downloadIsoWeldLogPdfFailure,

  fetchIsoMaterialFilterStart,
  fetchIsoMaterialFilterSuccess,
  fetchIsoMaterialFilterFailure,

  fetchWeldingGasFilterStart,
  fetchWeldingGasFilterSuccess,
  fetchWeldingGasFilterFailure,

  fetchWeldingMachineFilterStart,
  fetchWeldingMachineFilterSuccess,
  fetchWeldingMachineFilterFailure,

  fetchWeldingWPQFilterStart,
  fetchWeldingWPQFilterSuccess,
  fetchWeldingWPQFilterFailure,

  fetchWeldingLogFilterStart,
  fetchWeldingLogFilterSuccess,
  fetchWeldingLogFilterFailure,

  fetchNcrReportFilterStart,
  fetchNcrReportFilterSuccess,
  fetchNcrReportFilterFailure,

  fetchProjectReportFilterStart,
  fetchProjectReportFilterSuccess,
  fetchProjectReportFilterFailure,

  fetchWeldingMachineDownloadCSVStart,
  fetchWeldingMachineDownloadCSVSuccess,
  fetchWeldingMachineDownloadCSVFailure,
  fetchWeldingWPQDownloadCSVStart,
  fetchWeldingWPQDownloadCSVSuccess,
  fetchWeldingWPQDownloadCSVFailure,
  fetchWeldLogDownloadCSVStart,
  fetchWeldLogDownloadCSVSuccess,
  fetchWeldLogDownloadCSVFailure,
  fetchWeldingGasDownloadCSVStart,
  fetchWeldingGasDownloadCSVSuccess,
  fetchWeldingGasDownloadCSVFailure,
  fetchIsoMaterialDownloadCSVStart,
  fetchIsoMaterialDownloadCSVSuccess,
  fetchIsoMaterialDownloadCSVFailure,
} = inspectionDetailSlice.actions;

export default inspectionDetailSlice.reducer;
